<div class="company-container" *ngIf="reloadComponent">
  <div>
    <div nz-row nzType="flex" class="company-status-holder">
      <div nz-col nzSpan="24">
        <app-company-status
          *ngIf="metaReady && showStatus"
          [company]="ticker"
          (earningsPreviewEvent)="sendEarningsPreview()"
        >
        </app-company-status>
      </div>
    </div>
  </div>
  <div class="content">
    <div nz-row nzType="flex" nzGutter="10">
      <div nz-col style="width: calc(100% - 415px);">
        <div class="monitor-container">
          <app-line-item-monitor
            *ngIf="limMetaLoaded"
            [lineItemsMeta]="monitorMetaData"
            [ticker]="ticker"
          ></app-line-item-monitor>
        </div>
        <div class="analyst-model-container top-margin">
          <app-analyst-models [ticker]="ticker"></app-analyst-models>
        </div>
        <div class="research-container top-margin">
          <app-company-research> </app-company-research>
        </div>
      </div>
      <div nz-col style="width: 415px;">
        <div
          *ngIf="metaReady && companyFlag === 1"
          class="normalize-forecast-container"
        >
          <app-normalize-forecast [ticker]="ticker"></app-normalize-forecast>
        </div>
        <div
          class="drug-dashboard-section"
          *ngIf="metaReady && drugsCount > 0"
          [ngClass]="{
            'big-top-margin': companyFlag !== 1,
            'top-margin': companyFlag === 1
          }"
        >
          <div class="dashboard-info-container">
            <div class="header">
              <span class="header-text">{{ ticker }} on BioPharma</span>
              <span class="new-tag">New</span>
            </div>
            <div class="marketing-info">
              <span class="info-text"
                >View this company's drugs and competitors on BioPharma, our
                platform designed for healthcare workflows.</span
              >
            </div>
            <div class="drug-count-container">
              <div class="drug-count-section">
                <span class="title">Drugs</span>
                <span class="count">{{ drugsCount }}</span>
              </div>
            </div>
            <div class="link-section">
              <div *ngIf="hasPharmaAccess">
                <va-button
                  btnType="link"
                  size="medium"
                  (click)="redirectToPharma()"
                >
                  <va-icon
                    size="small"
                    name="external-link"
                    class="btn-icon"
                  ></va-icon>
                  <span class="btn-text">Open BioPharma</span>
                </va-button>
              </div>
              <div *ngIf="!hasPharmaAccess">
                <va-button
                  btnType="link"
                  size="medium"
                  class="btn-icon"
                  (click)="redirectToPharma()"
                >
                  <va-icon
                    name="external-link"
                    class="btn-icon"
                    size="small"
                  ></va-icon>
                  <span>Learn more</span>
                </va-button>
              </div>
            </div>
          </div>
        </div>
        <div
          class="tearsheet-container"
          [ngClass]="{
            'big-top-margin': companyFlag !== 1,
            'top-margin': companyFlag === 1
          }"
        >
          <app-company-tear-sheet
            [company]="ticker"
            [disableDownload]="isTearSheetDownloadable"
          >
          </app-company-tear-sheet>
        </div>
        <div class="activity-feed-container top-margin">
          <app-activity-feed
            *ngIf="metaReady"
            [defaultData]="activityFeedObj"
          ></app-activity-feed>
        </div>
      </div>
    </div>
  </div>
</div>
